import { render, staticRenderFns } from "./ReportAlertList.vue?vue&type=template&id=0084d98d&scoped=true&"
import script from "./ReportAlertList.vue?vue&type=script&lang=js&"
export * from "./ReportAlertList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0084d98d",
  null
  
)

export default component.exports